// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.AnalyticsProductLevel

export enum AnalyticsProductLevel {
  ALL = 'ALL',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  L4 = 'L4',
  L5 = 'L5',
  NONE = 'NONE',
}

export const AnalyticsProductLevel_values = [
  AnalyticsProductLevel.ALL,
  AnalyticsProductLevel.L1,
  AnalyticsProductLevel.L2,
  AnalyticsProductLevel.L3,
  AnalyticsProductLevel.L4,
  AnalyticsProductLevel.L5,
  AnalyticsProductLevel.NONE,
] as const;
